// Central catalogue of projects.
// Images are served directly from Google Drive's public CDN
// (lh3.googleusercontent.com) — no storage or auth required.

// Small helper: build a Drive CDN URL for a given file id.
// The =w2000 suffix requests a ~2000px-wide rendition (good for retina).
const img = (id) => `https://lh3.googleusercontent.com/d/${id}=w2000`;

// Cycle over a set of aspect ratios so masonry grids feel editorial
// even when the source photos have varied orientations.
const RATIOS = [
  "aspect-[4/5]",
  "aspect-[3/4]",
  "aspect-[3/2]",
  "aspect-square",
  "aspect-[4/5]",
  "aspect-[3/4]",
  "aspect-[16/10]",
];
const buildGallery = (ids) =>
  ids.map((id, i) => ({ src: img(id), ratio: RATIOS[i % RATIOS.length] }));

// ---------------- File IDs (from Google Drive folder) ----------------
const CONCEPTUAL_IDS = [
  "1jHpg6S43_hyJ9NQjJ1klW7iDtPowEo4O", // 1
  "1Voo-_wnbfdojSRCv6yQsyvbWQ3XIiNpa", // 2
  "11FS75toWr3iV0lUWkCGUnnxPWouwtxDr", // 3
  "1V00y7A4vWupxIt2KY3iubHIL4fmvr_MO", // 4
  "1BqN5gl3tWgRyDLB9zzoyD_rXG_e_tBo_", // 5
  "1Hh4kOB3mlJ42tia8mgUY51chOHL9P1oj", // 6
];

const DOCUMENTARY_IDS = [
  "1mloci3yXl-MGbppRgZR_z9Wum6jtVT-z",
  "1KkRVJDIMCCDRp7hERfI8EgP8kgxFewrV",
  "1XNLlc-wQra6kT7_U1qzwinlFaKV0h77u",
  "1-ybnQBL8O29DxAkV8OO54cAiD-2bSu9e",
  "11OFNKqks3koAU6mlqAD4kNa_jyVpOdWn",
  "1OSCki4Hu9qUDi0MtEzhp4_0Qy1AwR4Lo",
  "1OManUK-5jMp-goxJCs5pQY4Ae2pcGvPe",
  "1Y9zCM0E6NmMDbWLZOKKw-4HEs5_dpWfh",
  "1plTmYiONYeFyoLp9wZrCaZU5_adCjtvB",
  "1mCB-3LGso8m0wsttJmFKkCKrmAzSy8RG",
  "1Zhux2hPgN5boIHJnO9EaxfK10IrJcIoR",
  "1AJNuCUtPHUqgYtvrGmQ1K2bnUZunyLHX",
  "1lNWUqSB4UmoCcqbiih1Hwlzthl5OEQlM",
  "1XWcgzz4S-VxNu3p3OJ3lMiFf01WvKo6j",
  "1xQijDqE2R6XJvO1OvVkFkiYfZGDWphyD",
  "1L8CUJLw-i7BexkHBDkc2P1_v0qntiUZX",
  "1LHh2MfxmgjYT4olgLucb0I46V76S-t6N",
  "10lavxR9McxkFYcILpwb9eI5b6UsD69zu",
  "11jvwF76y0A_WwUFNnwN0w6B_Mt9Bj0vm",
  "18zY9MpHMZQwv_fXqGwyv7x5MlUIZIyVo",
  "1l79hfW2HqHLBdOEcIty9Y7KAtQYHa-Bx",
];

const ARCHITECTURE_IDS = [
  "1yfjbelVr_rEpl1tMj-0k0UXH7a7NyQOL",
  "1m2mBGVcFyS-LvwfvWkevfmWAqEHFqtd4",
  "1qXoc0401MkM1crvVbfeVqOFDzs5qy27n",
  "1427qarMbXEOES9ljUC3jM_PTUTQPJv8u",
  "1LMu2OUNR1d-1ZdqiwG0acFXMnCCCckIP",
  "1wrc84L-1rSixDMcMFD7WmBxj4i0LMqz8",
  "1Hc8Ce7ye4Cb4PW23nEigOkzh9Fb80eSJ",
  "1lG9darKy7QaATck1ndkNWULG4TmtJd2P",
  "1U03sTjnKBF8QAB-__2vd2ts4-1A_tKrH",
];

const PRODUCT_IDS = [
  "12WREFA7vrup-yh8D0kUAhmfssoW5-rHZ",
  "12o-rgPBHMBRz6PiIpHuu47McKBcX4U21",
  "1iX9M-Hng_gIPxRKDegCLKiM3hoM0ZL64",
  "1m8msdGVSFF0pl_By5QT-zVj9xG7lJ7jK",
  "1Rhe0UOFfEpWStMohuMa97dxIng3_bxda",
];

const PORTRAIT_01_IDS = [
  "1eRu0CwqNL1i-x5K5PshdJGCMEfU5HIC1",
  "1_TcAG0AgbwbJfnr0f1Tx5XQeHPHQshOW",
  "1lQfaqKwwDb1sDvS_TkvxTxkRdjJj8m6p",
  "1kD8jzxNgE0musOteTfGz8-0hAC_LY_7n",
  "1__xYMOAk5MYMl00ZCf55zgImediSMSEf",
  "1FmYjrlztoE4DjAFwKTGI3dd-HoCHszVp",
  "1s2_L_HhJih90oj6T8CjH6SBIbMUiKph7",
  "1XvPfF0lJHLKu9h9JAWSaOg7vmsgbsImX",
];

const PORTRAIT_02_IDS = [
  "1f40ubeCxweSTH2xGVB3fqjLEm5IQwDXA",
  "1iLPsdfKIdbKpjMHTzP3iBWqs9Z2TcrGT",
  "1Q9NBmyROoJOYDBoddSWPRbnr63yPeWKN",
  "1kTieR-i3Awtck7lQXcwcj5DDqtUTyaRX",
  "1gPcr2lqsmR5lMT_Pyl_jPSXTQeZfBwlo",
  "14dvIHYQFtLMbt6SW7zIq23nj56hX8_HW",
  "1ScnA5TwnlQocoh-gIyrhc5qxC2WNeYS-",
  "1RKDxwvj-XV68FfHan0y1nDvi8Bedmb-_",
  "1psXujqGCVxRl06EWy1LBuXoZQmQbqWmr",
  "1zXFn0IyrgJ-RG_OiTTN1lLMkBXmnVWOg",
  "1S87e50tBP88aNeOeWYcAHgVNQ8Fh7z8E",
  "12D5zRu48Z0PyWSfvJJwF66vN6FyVnWOe",
  "1o9xSbMCfaGlqgWBeJJyhUZ2ZU0k-UBGW",
  "1uKqlTjsoRJhhiQm3ferXu0548UGilYGy",
  "1UzGk1NuHudwTbQo_0unLIYdBloUqCxZ8",
  "1B_q8qPSj_fU9S1tNLjJhPjOuz_Uo32xs",
];

const PORTRAIT_03_IDS = [
  "1ILWlZMBkTQWgL6LuuRAwEBJXqjtj_lnW",
  "1x5xv7_usYivy4_3VMk4MfCri9sr3CZN4",
  "1mC8MTfUH21v9HRRFk77-MpusEoKMKv2q",
  "1f7XWdUozwxF97YOixKE1MaWssVDt1FiL",
  "1JoExnz1lu8OxYDkHp8Ca4XOGglXWXXnK",
  "134wbgDloaOWvVVSEMWg58YNY_W2kUHjo",
  "1iV_41ueV4rlFTa2du9YWPnaPQDf2XoIB",
  "1P2GHnKRlAqSnAPVOIPfqSZrVG7hEeKRR",
  "111eB-JID1mPcrWY0psS12VXPAdNtJVF5",
  "1x6jhEeVE8yGa3VfiHm4qdAkh8zUOZ9B6",
  "1QLgXULy028eSQHtmsn_jPl3n3l8-rmqR",
  "1FzeBWLme12qKWgF8cUMAaJxTfpR_44Sz",
  "1FVoazwVcAwEpqWZJMl1UggxTVAU6FPUt",
  "1dHlKgQc74SasBiK00mHmIer3ZuyJmKWs",
  "1_ibgvPPlJGLLhToh2_cWrd6UedUAPIzc",
  "1ThrL-d5y_QA4tadcGKb0UdTkMNlh4N6o",
  "1kisrhdPBRPttifMz4xOMPhq7K6yPgi82",
  "1gB1IrZMZREKsCfrSztc_u291m_g8Y14N",
  "1-W_snOKCKVY1E4m4nUf-A9olqcft02N3",
  "1U3Qafbr3iFWKguxC43F9SckxL3A4t6XA",
  "10NeymXnEmI4_Ua9nI0UblwJBoEAJvbm5",
  "1fzX7iEb-ND0yVXnLP50XoFk-Z0kjUZ_a",
  "1RIAHOR4jeNGedLAqOqmeR8rjlsQrLyoA",
  "1rnnXcUP4H66AoxwZsDtPg9qOxKsVhCNv",
  "1xlk23GiiBPXb_3Vvsc1_1mJyip8f_37j",
  "1RQO74exYkabEn8uXqYjJTyCYmxeEiLrb",
  "1TCFqU1SDfT48xZMsjKZT5pKWAUaOsxis",
  "13ZLyDjsMB6_H5giKrvqHHaqi1WDV6_n0",
  "19DjxCpi_4Dz2W1pZaI-ueysH_Bw7Fdhs",
  "1LaD87Ge2QrD9GN-w7uB8YmgGwVmJU0ad",
  "1nuqSE_yZ2Ag_ufxhFieSALzARixoJ-QV",
  "1jUyksy6ktPC3n831B2aE8URn2I1fSLGd",
  "1A7afT4-KzcgiK9TdymzF4UpT6HU5LZMB",
  "1r-J3N6dHy50bcFYdtLy8vbhqZwJup96a",
];

// ---------------- Public helpers ----------------
export const cdnImage = img;

// About-page portrait — supplied directly by STXP (uploaded asset)
export const aboutPortraitImage =
  "https://customer-assets.emergentagent.com/job_editorial-light-1/artifacts/49b5xenv_meme.png";

// Small round profile icon used in the site navigation
export const profileIconImage =
  "https://customer-assets.emergentagent.com/job_editorial-light-1/artifacts/t6z6s0jb_IMG-20260627-WA0008%281%29.jpg";

// -----------------------------------------------------------------------------
// Categories — this is the "folder" structure of the portfolio.
// To add a new category later, simply add an entry here and start adding
// projects with the matching `category` label.
// -----------------------------------------------------------------------------
export const categories = [
  {
    slug: "conceptual",
    label: "Conceptual",
    description:
      "Editorial narratives and constructed imagery — meaning built through composition, light and quiet symbolism.",
  },
  {
    slug: "documentary",
    label: "Documentary",
    description:
      "Fragments of everyday life — the ordinary rendered attentive. People, place and time, observed.",
  },
  {
    slug: "architecture",
    label: "Architecture",
    description:
      "Studies of built form, light and negative space. A visual conversation between geometry and atmosphere.",
  },
  {
    slug: "product",
    label: "Product",
    description:
      "Editorial product work with a soft, tactile sensibility. Focused on material, tone and quiet composition.",
  },
  {
    slug: "portrait",
    label: "Portrait",
    description:
      "Collaborative sessions — experimenting with flash, harsh light and dynamic composition, where the lighting itself becomes part of the visual story.",
  },
];

export const projects = [
  {
    slug: "product",
    title: "Product Photography Sample",
    category: "Product",
    date: "5 July 2026",
    description:
      "Editorial product work with a soft, tactile sensibility. Focused on material, tone and quiet composition.",
    longDescription: [
      "Created as part of a photography course exploring the relationship between color and emotion, this series focuses on how color influences mood and visual perception. While developed as a creative study, the clean compositions and attention to detail naturally align with the aesthetics of product photography.",
    ],
    hero: img("1iX9M-Hng_gIPxRKDegCLKiM3hoM0ZL64"), // _DSC3060
    gallery: buildGallery(PRODUCT_IDS),
  },
  {
    slug: "documentary",
    title: "Jan Haring Weekend 2026",
    category: "Documentary",
    date: "3–5 July 2026",
    description:
      "A three-day documentary series from the Jan Haring Weekend — fragments of everyday life, the ordinary rendered attentive.",
    longDescription: [
      "I had such a great time photographing the Jan Haring Weekend this Saturday. During those days, Monnickendam comes alive with sailing, local traditions, and a great community atmosphere.",
      "From Friday to Sunday, sailors and visitors gather at the harbor as boats arrive and the weekend officially begins with a welcome gathering in the event tent. It was amazing to see the harbor full of beautiful sailing boats and to experience the atmosphere of the event first-hand.",
      "On Saturday and Sunday, the competing boats head out onto the Markermeer to race. After a briefing, the different sailing classes set off for their competitions just outside Monnickendam. Once the races are over, everyone returns to the harbor. From exciting races on the water to the lively energy back at the harbor, every part of the day had something unique to photograph.",
      "Sailors share stories from the day's races, spend time together, and celebrate the weekend before the event comes to an end. The weekend wraps up on Sunday with the official prize ceremony, where the winners are announced and the event officially closes.",
      "I'm really grateful I had the opportunity to be there and document such a wonderful local tradition. Thank you to everyone who made this event so special — I hope these photos capture at least a small part of what the weekend felt like.",
    ],
    hero: img("1XNLlc-wQra6kT7_U1qzwinlFaKV0h77u"), // _DSC2782
    gallery: buildGallery(DOCUMENTARY_IDS),
  },
  {
    slug: "portrait-03",
    title: "Portrait Session",
    category: "Portrait",
    date: "30 June 2026",
    description:
      "Documentary portraiture on location — an extended collaborative session capturing the person, not the pose.",
    hero: img(PORTRAIT_03_IDS[0]), // _DSC2557
    // Slight left-of-centre crop
    heroObjectPosition: "object-[40%_center]",
    longDescription: [
      "Earlier that day, I attended a Sony camera workshop during a local photography festival, so my camera stayed with me long after the event ended. Later, while exploring the heart of Amsterdam with friends, we discovered a spot near the Dutch National Opera & Ballet that instantly inspired us.",
      "The light, colors, and atmosphere came together naturally, turning an ordinary afternoon into one of those rare creative moments where every frame felt effortless.",
      "It's one of the shoots that reminds me why I love photography — not just for the final images, but for the feeling of being completely immersed in the creative process.",
    ],
    gallery: buildGallery(PORTRAIT_03_IDS),
  },
  {
    slug: "carry-the-light",
    title: "Carry the Light",
    category: "Conceptual",
    date: "27 June 2026",
    description:
      "My diploma project — a conceptual series shot as an editorial narrative.",
    longDescription: [
      "This photo series explores the transformation of a deep emotional bond between two people and the process of adapting to its absence. Rather than telling the story of specific individuals, the project presents a visual interpretation of connection, separation, and personal growth through gesture, light, and space.",
      "At the center of the series is a relationship built on mutual understanding, trust, and acceptance. The two individuals are represented only through their hands, emphasizing that the story is not about identity, appearance, or personal details, but about the emotional space created between them. Their connection is portrayed as a rare sense of comfort — a feeling of being understood without explanation, of finding a place where both people can exist freely as themselves.",
      "Throughout the series, light serves as a visual metaphor for this shared emotional space. It does not represent love alone, but the intangible connection created through trust, presence, understanding, and mutual acceptance. The light exists only when both individuals contribute to it. As the relationship changes, the light changes with it.",
      "The narrative begins with a state of balance and emotional security. The two people experience one another as a source of comfort and stability while maintaining their own individuality. Although they have separate futures, ambitions, and personal identities, their paths coexist harmoniously. The light between them symbolizes this shared space they have built together.",
      "As the series progresses, subtle tension emerges. Small uncertainties begin to appear, not because the connection is weak, but because both individuals become aware that circumstances beyond their control may eventually challenge it. The emotional tension is not caused by conflict between them, but by the fear of what might happen when their bond is tested by reality.",
      "The turning point arrives when external pressure disrupts the relationship. The separation is not the result of fading feelings, betrayal, or a loss of care. Instead, one person chooses distance as a way to cope with overwhelming circumstances. The decision to withdraw comes from a need for self-preservation rather than a lack of love. As a result, the connection breaks despite the feelings that still remain.",
      "For the person left behind, the most painful aspect of the separation is not the loss itself, but the inability to face the struggle together. What remains is a complex mixture of emotions: emptiness, confusion, disappointment, longing, affection, empathy, and unresolved questions. The absence of closure creates a sense of emotional suspension, represented visually through the disappearance of light and the increasing isolation of the hands.",
      "However, the final part of the series is not focused on loss. It explores acceptance. The remaining figure gradually learns that moving forward does not require abandoning love, forgetting the past, or denying difficult emotions. Instead, growth begins through acknowledging them honestly. The experience becomes a source of self-respect, resilience, and deeper self-understanding.",
      "The final image represents a shift in the source of light. In the beginning, light existed between two people. By the end, light appears ahead of a single individual. This does not symbolize a replacement for the lost connection, nor does it suggest a definitive ending. Rather, it reflects the discovery of an inner foundation — the realization that life can continue even when answers remain unknown.",
      "Ultimately, the series suggests that some relationships leave a lasting mark regardless of their outcome. Even when circumstances force people apart, the understanding, strength, and self-acceptance gained through that connection remain. The story concludes not with resolution, but with the possibility of a future built upon what was learned, carrying both gratitude and uncertainty forward.",
    ],
    coreMessage:
      "Moving forward does not require letting go of love. Sometimes it means learning how to carry it while continuing to grow.",
    hero: img(CONCEPTUAL_IDS[0]),
    gallery: buildGallery(CONCEPTUAL_IDS),
  },
  {
    slug: "architecture",
    title: "Architecture Project",
    category: "Architecture",
    date: "9 June 2026",
    description:
      "Studies of built form, light and negative space. A visual conversation between concrete geometry and Dutch atmosphere.",
    hero: img("1wrc84L-1rSixDMcMFD7WmBxj4i0LMqz8"), // _DSC2427
    // Subtle leftward crop shift
    heroObjectPosition: "object-[65%_center]",
    longDescription: [
      "One of my architecture photography walks during the course (May – June 2026).",
      "The assignment was to photograph architecture while applying the composition and observation techniques we had been learning. I decided to give myself an extra challenge by focusing on color — looking for bright facades, playful details, bold contrasts, and buildings with their own personality. It completely changed the way I explored the city and made me notice details I would have otherwise walked past.",
    ],
    gallery: buildGallery(ARCHITECTURE_IDS),
  },
  {
    slug: "portrait-02",
    title: "Portrait Session",
    category: "Portrait",
    date: "5 June 2026",
    description:
      "A studio-led exploration of presence and gesture. Soft palette, muted grain, deliberate stillness.",
    hero: img("1psXujqGCVxRl06EWy1LBuXoZQmQbqWmr"), // _DSC2256
    longDescription: [
      "This evening shoot in Amsterdam's Vondelpark began as an opportunity to experiment with my new Godox V480S flash. Together with my friend, we intentionally explored harsh lighting to create a mysterious, cinematic atmosphere.",
      "Rather than chasing soft, flattering light, we embraced strong shadows and contrast, allowing the lighting itself to become a key part of the visual story.",
    ],
    gallery: buildGallery(PORTRAIT_02_IDS),
  },
  {
    slug: "portrait-01",
    title: "Portrait Session",
    category: "Portrait",
    date: "4 May 2026",
    description:
      "An intimate portrait session — natural light, considered pace, and the honesty that appears in between frames.",
    hero: img("1_TcAG0AgbwbJfnr0f1Tx5XQeHPHQshOW"), // DSC01634
    heroObjectPosition: "object-[20%_center]",
    longDescription: [
      "This was my very first portrait photoshoot with friends, spent exploring the streets of Hoorn over the course of a full day. It became a turning point in my journey as a photographer, as I began experimenting with dynamic compositions, movement, and the bold look of harsh flash photography.",
      "Having only just started using my Godox V480S flash, I was still learning how light behaved in different situations, making every frame part of the learning process.",
      "This was also one of my first experiences editing in Lightroom, so the entire project reflects a period of exploration, experimentation, and rapid creative growth.",
    ],
    gallery: buildGallery(PORTRAIT_01_IDS),
  },
];

// The most recent project — used as the "Latest series" badge on the Home hero.
export const latestProject = projects[0];

export const journalUrl = "https://tpechnx.wixsite.com/photographic-blog";

export const contactInfo = {
  email: "contact@stxpphoto.com",
  instagram: "@stxp_photo",
  instagramUrl: "https://instagram.com/stxp_photo",
  whatsapp: "+31 6 49256605",
  whatsappUrl: "https://wa.me/31649256605",
};

export function getProjectBySlug(slug) {
  return projects.find((p) => p.slug === slug);
}

export function getAdjacentProjects(slug) {
  const idx = projects.findIndex((p) => p.slug === slug);
  if (idx === -1) return { prev: null, next: null };
  const prev = idx > 0 ? projects[idx - 1] : projects[projects.length - 1];
  const next = idx < projects.length - 1 ? projects[idx + 1] : projects[0];
  return { prev, next };
}

// ---- Category helpers ----
export function getCategoryBySlug(slug) {
  return categories.find((c) => c.slug === slug);
}

export function getProjectsByCategory(slug) {
  return projects.filter((p) => p.category.toLowerCase() === slug.toLowerCase());
}

// Returns a preview object for a category — cover image + project count.
export function getCategoryPreview(slug) {
  const items = getProjectsByCategory(slug);
  const cover = items[0]?.hero || "";
  return { cover, count: items.length, projects: items };
}
